import {FC} from 'react'

import {IconSize} from '@/theme/icons'
import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

type QuestionMarkIconProps = IconProps & {
  backgroundColor?: string
  borderColor?: string
}

export const QuestionMarkIcon: FC<React.PropsWithChildren<QuestionMarkIconProps>> = ({
  color = theme.palette.gray[400],
  size = IconSize.small,
  backgroundColor = 'transparent',
  borderColor = color,
}) => (
  <>
    <Icon size={size}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="8" cy="8" r="7.25" fill={backgroundColor} />
        <path
          d="M8 5C7.30965 5 6.75 5.55965 6.75 6.25C6.75 6.66422 6.41422 7 6 7C5.58578 7 5.25 6.66422 5.25 6.25C5.25 4.73122 6.48122 3.5 8 3.5C9.51878 3.5 10.75 4.73122 10.75 6.25C10.75 7.38099 10.0721 8.25285 9.5201 8.78412C9.23308 9.06038 8.94893 9.27495 8.7374 9.42037C8.61555 9.50414 8.49107 9.58578 8.36143 9.65717C7.9985 9.85678 7.54245 9.72438 7.34283 9.36144C7.14352 8.99906 7.27521 8.54387 7.63687 8.34377L7.6378 8.34326C7.94308 8.16843 8.22696 7.94683 8.4799 7.70338C8.92793 7.27215 9.25 6.76901 9.25 6.25C9.25 5.55965 8.69035 5 8 5Z"
          fill={color}
        />
        <path
          d="M8 12.5C8.41422 12.5 8.75 12.1642 8.75 11.75C8.75 11.3358 8.41422 11 8 11C7.58578 11 7.25 11.3358 7.25 11.75C7.25 12.1642 7.58578 12.5 8 12.5Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.75 8C0.75 3.99593 3.99594 0.75 8 0.75C12.0041 0.75 15.25 3.99593 15.25 8C15.25 12.0041 12.0041 15.25 8 15.25C3.99594 15.25 0.75 12.0041 0.75 8ZM8 2.25C4.82436 2.25 2.25 4.82436 2.25 8C2.25 11.1756 4.82436 13.75 8 13.75C11.1756 13.75 13.75 11.1756 13.75 8C13.75 4.82436 11.1756 2.25 8 2.25Z"
          fill={borderColor}
        />
      </svg>
    </Icon>
  </>
)
